import CommonButton from "@/components/common/Analytics/CustomButton";
import styles from "./FeesCard.module.scss";
import cn from "clsx";
import Image from "next/image";
import ArrowRight from "@/SvgIcons/ArrowRight";

export default function FeesCard({
  FeesInInr = "",
  FeesInUSD = "",
  SecondaryHeading= "",
  HeadingDescription= "",
  HeadingDescriptionForUS = "",
  Image: ImageAttr= "",
  country= "",
  classname= "",
  imgClass= "",
  isScholarshipAvailable= "",
  isCampusImmersionPage= "",
  isLandingPage=false,
  isStrikeThrough = false,
}: any) {
  return (
    <div
      className={`rounded-2xl flex items-center  justify-between lining-nums ${styles.root} ${classname}`}
    >
      <div
        className={`text-raleway h-full flex flex-col ${isLandingPage?"justify-center":"justify-between"}  ${styles.FeesCard__Container} ${isScholarshipAvailable ? styles.FeesCard__ContainerScholarship : ""}`}
      >
        <p className={cn(`font-medium`, styles.FeesSection__Heading)}>
          {SecondaryHeading}
        </p>
        <div>
          <h2 className="text-[42px] font-extrabold lg:text-[48px] lg:leading-[70px] lining-nums">
            {country === "IN" ? FeesInInr : FeesInUSD}
          </h2>
          {isStrikeThrough && (<div className={styles.strikeThrough}>
            <del>
              <h3 className="text-[18px] leading-[22px] font-medium lg:text-[2.4rem] lg:leading-[26.48px]">
            {country === "IN" ? HeadingDescription: HeadingDescriptionForUS}
          </h3>
            </del>
          </div>
          ) }
          {!isStrikeThrough && <h3 className="text-[18px] leading-[22px] font-medium lg:text-[22.697px] lg:leading-[26.48px]">
            {country === "IN" ? HeadingDescription: HeadingDescriptionForUS}
          </h3>}
        </div>
        {isScholarshipAvailable && !isLandingPage &&  <a href="/scholarship"  className={`${styles.cus_btn} ${isCampusImmersionPage ? styles.campursionEmersionClass :styles.customBackground}`}>
        Explore Now
      <ArrowRight color="#1A325B"/>
        </a>}
      </div>
      {!isScholarshipAvailable && <div className="h-full">
        <Image
          src={ImageAttr?.data?.attributes?.url}
          alt={ImageAttr?.data?.attributes?.alternativeText || "Fees Card"}
          className={`h-[102px] w-[90px] lg:h-full c lg:w-auto ${imgClass}`}
          width={90}
          title="Fees Card"
          height={100}
        />
      </div>}
    </div>
  );
}
